import { useQuery } from "@tanstack/react-query";
import { http } from "@/lib/api";

// CoinIcon CDN — referans HTML'inden alındı (cdnjs üzerinden)
const ICON_BASE =
  "https://cdn.jsdelivr.net/npm/cryptocurrency-icons@0.18.1/svg/color";

const slugOf = (sym) => (sym || "").replace(/USDT$/i, "").toLowerCase();

export default function Pairs() {
  const { data, isLoading } = useQuery({
    queryKey: ["eligible-pairs"],
    queryFn: () => http.get("/meta/eligible-pairs").then((r) => r.data),
    staleTime: 5 * 60_000,
  });

  const pairs = data?.pairs || [];

  return (
    <div style={{ padding: "20px", maxWidth: 1100 }} data-testid="pairs-page">
      <section className="tx-card">
        <span className="tx-cb3" />
        <span className="tx-cb4" />
        <div className="tx-ch-head">
          <div className="tx-ch-ic" aria-hidden>
            <svg viewBox="0 0 24 24">
              <path d="M12 2 4 5v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V5l-8-3z" />
              <path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="tx-ch-tt">
            <h2>
              Uygun Pariteler <span className="n">({pairs.length})</span>
            </h2>
            <div className="sub">Hedge için kabul edilen coinler</div>
          </div>
        </div>

        <div className="tx-card-b">
          {isLoading ? (
            <div style={{ color: "#6b7280", fontSize: 12 }}>
              Pariteler yükleniyor…
            </div>
          ) : (
            <>
              <div className="tx-pars" data-testid="pairs-grid">
                {pairs.map((sym) => {
                  const slug = slugOf(sym);
                  return (
                    <div
                      key={sym}
                      className="tx-par-chip on"
                      data-sym={sym}
                      data-testid={`pair-chip-${sym}`}
                    >
                      <span className="coin">
                        <img
                          alt={slug}
                          src={`${ICON_BASE}/${slug}.svg`}
                          width="26"
                          height="26"
                          onError={(e) => {
                            // CDN'de ikon yoksa — generic gri arka plan
                            e.currentTarget.style.display = "none";
                          }}
                        />
                      </span>
                      <span className="tk">
                        <b>{sym.replace(/USDT$/i, "")}</b>
                        <span className="q">USDT</span>
                      </span>
                      <span className="chk" aria-hidden>
                        <svg viewBox="0 0 24 24">
                          <path d="M20 6 9 17l-5-5"
                                strokeLinecap="round"
                                strokeLinejoin="round" />
                        </svg>
                      </span>
                    </div>
                  );
                })}
              </div>
              <div className="tx-pars-hint">
                <span className="d" />
                Logolar otomatik yüklenir · <b>{pairs.length} parite aktif</b>
                {" · "}Yeni parite eklemek için Admin → Ayarlar
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
